

// ************************************************************************************************************************************

// *************************************************************************************************************************************

// import React, { Component } from "react";
// import { NavLink, withRouter } from "react-router-dom";
// import Button from "@material-ui/core/Button";
// import GlobalURL from "appUtility/global";
// import featureServer from "./../../appUtility/featureServer";
// import { httpClient } from "appUtility/Api";
// import qs from "qs";

// import IntlMessages from "util/IntlMessages";
// import CustomScrollbars from "util/CustomScrollbars";
// import Snackbar from '@material-ui/core/Snackbar';
// import Alert from '@material-ui/lab/Alert';
// import { Link } from 'react-router-dom';

// // Add these imports for drawer controls
// import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
// import ChevronRightIcon from '@material-ui/icons/ChevronRight';

// const loginData = JSON.parse(localStorage.getItem("login"));

// class SidenavContent extends Component {
//   constructor() {
//     super();

//      const savedDrawerState = localStorage.getItem('downloadDrawerOpen');
//     this.state = {
//       showButton: false,
//       categories: [],
//       iosSnackbarOpen: false,
//       iosSnackbarMessage: "",
//       iosDownloadLink: "",
//       isIosLoading: false,
//       // Add download drawer state only
//        downloadDrawerOpen: savedDrawerState === null
//         ? true               // default if not set
//         : savedDrawerState === 'true',
//     };
//   }
  
//   componentDidMount() {
//     // Check if download drawer state is saved in localStorage
//     // const savedDrawerState = localStorage.getItem('downloadDrawerOpen');
//     // if (savedDrawerState !== null) {
//     //   this.setState({ downloadDrawerOpen: savedDrawerState === 'true' });
//     // }
    
//     const loginOBJ = JSON.parse(localStorage.getItem("login"));
//     const { aid, cid } = loginOBJ;

//     httpClient
//       .post(
//         "v2/trainingCategories.php",
//         qs.stringify({
//           action: "getList",
//           "source[appID]": aid,
//           "source[companyID]": cid,
//         })
//       )
//       .then((res) => {
//         if (res.data.success) {
//           this.setState({ categories: res.data.data });
//         }
//       })
//       .catch((error) => {
//         console.error("Error fetching categories:", error);
//       });

//     this.checkTime();

//     this.intervalId = setInterval(this.checkTime, 60000);

//     const { history } = this.props;
//     const that = this;
//     const pathname = `${history.location.pathname}`; // get current path

//     const menuLi = document.getElementsByClassName("menu");
//     for (let i = 0; i < menuLi.length; i++) {
//       menuLi[i].onclick = function(event) {
//         for (let j = 0; j < menuLi.length; j++) {
//           const parentLi = that.closest(this, "li");
//           if (
//             menuLi[j] !== this &&
//             (parentLi === null || !parentLi.classList.contains("open"))
//           ) {
//             menuLi[j].classList.remove("open");
//           }
//         }
//         this.classList.toggle("open");
//       };
//     }

//     const activeLi = document.querySelector('a[href="' + pathname + '"]'); // select current a element
//     try {
//       const activeNav = this.closest(activeLi, "ul"); // select closest ul
//       if (activeNav.classList.contains("sub-menu")) {
//         this.closest(activeNav, "li").classList.add("open");
//       } else {
//         this.closest(activeLi, "li").classList.add("open");
//       }
//     } catch (error) {}
//   }

//   componentWillUnmount() {
//     // Cleanup interval on component unmount
//     clearInterval(this.intervalId);
//   }

//   checkTime = () => {
//     // Get the current date and time in Australian Eastern Time (Sydney)
//     const now = new Date();
//     const options = {
//       timeZone: "Australia/Sydney",
//       year: "numeric",
//       month: "2-digit",
//       day: "2-digit",
//       hour: "2-digit",
//       minute: "2-digit",
//       second: "2-digit",
//       hour12: false,
//     };
//     const formatter = new Intl.DateTimeFormat("en-AU", options);
//     const parts = formatter.formatToParts(now);
//     const dateParts = parts.reduce((acc, part) => {
//       acc[part.type] = part.value;
//       return acc;
//     }, {});

//     const currentDate = new Date(
//       `${dateParts.year}-${dateParts.month}-${dateParts.day}T${dateParts.hour}:${dateParts.minute}:${dateParts.second}+10:00` // +10:00 for AEST
//     );

//     // Define the target date and time: June 28, 2024, 6:30 PM in Sydney
//     const targetDate = new Date("2024-06-30T15:25:00+10:00"); 

//     // Check if the current date and time is after the target date and time
//     if (currentDate >= targetDate) {
//       this.setState({ showButton: true });
//     } else {
//       this.setState({ showButton: false });
//     }
//   };

//   componentWillReceiveProps(nextProps) {
//     const { history } = nextProps;
//     const pathname = `${history.location.pathname}`; // get current path

//     const activeLi = document.querySelector('a[href="' + pathname + '"]'); // select current a element
//     try {
//       const activeNav = this.closest(activeLi, "ul"); // select closest ul
//       if (activeNav.classList.contains("sub-menu")) {
//         this.closest(activeNav, "li").classList.add("open");
//       } else {
//         this.closest(activeLi, "li").classList.add("open");
//       }
//     } catch (error) {}
//   }

//   closest(el, selector) {
//     try {
//       let matchesFn;
//       // find vendor prefix
//       [
//         "matches",
//         "webkitMatchesSelector",
//         "mozMatchesSelector",
//         "msMatchesSelector",
//         "oMatchesSelector",
//       ].some(function(fn) {
//         if (typeof document.body[fn] == "function") {
//           matchesFn = fn;
//           return true;
//         }
//         return false;
//       });

//       let parent;

//       // traverse parents
//       while (el) {
//         parent = el.parentElement;
//         if (parent && parent[matchesFn](selector)) {
//           return parent;
//         }
//         el = parent;
//       }
//     } catch (e) {}

//     return null;
//   }

//   // Toggle download drawer only
//   toggleDownloadDrawer = () => {
//     const newState = !this.state.downloadDrawerOpen;
//     this.setState({ downloadDrawerOpen: newState });
//     localStorage.setItem('downloadDrawerOpen', newState.toString());
//   };

//   // handleDownloadIOS = () => {
//   //   const loginOBJ = JSON.parse(localStorage.getItem("login"));
//   //   const { aid, cid } = loginOBJ;

//   //   this.setState({
//   //     isIosLoading: true,
//   //     iosSnackbarMessage: "Preparing download link...",
//   //     iosSnackbarOpen: true,
//   //     iosSnackbarSeverity: "success"
//   //   });

//   //   // Make API call to get download link
//   //   httpClient
//   //     .post(
//   //       "v2/downloadLink.php",
//   //       qs.stringify({
//   //         action: "getLink",
//   //         "source[appID]": aid,
//   //         "source[companyID]": cid,
//   //       })
//   //     )
//   //     .then((res) => {
//   //       if (res.data.success) {
//   //         this.setState({
//   //           iosSnackbarMessage: res.data.message || "Download link ready! Redirecting...",
//   //           iosDownloadLink: res.data.download,
//   //           iosSnackbarSeverity: "success"
//   //         });

//   //         // Wait 2 seconds before redirecting
//   //         setTimeout(() => {
//   //           window.open(res.data.download, "_blank");
//   //           this.setState({
//   //             isIosLoading: false,
//   //             iosSnackbarOpen: false
//   //           });
//   //         }, 2000);
//   //       } else {
//   //         const errorMessage = res.data.message || "Failed to get download link. Please try again.";
//   //         this.setState({
//   //           iosSnackbarMessage: errorMessage,
//   //           iosSnackbarSeverity: "error",
//   //           isIosLoading: false
//   //         });
//   //       }
//   //     })
//   //     .catch((error) => {
//   //       console.error("Error fetching download link:", error);
//   //       this.setState({
//   //         iosSnackbarMessage: "Network error. Please check your connection.",
//   //         iosSnackbarSeverity: "error",
//   //         isIosLoading: false
//   //       });
//   //     });
//   // };

//   handleSnackbarClose = (event, reason) => {
//     if (reason === 'clickaway') {
//       return;
//     }
//     this.setState({ iosSnackbarOpen: false });
//   };

//   handleOpenNewPage = () => {
//     window.open("https://bluewheelers.opcentral.com.au", "_blank");
//   };

//   render() {
//     const { categories } = this.state;
//     return (
//       <>
//         <CustomScrollbars className=" scrollbar">
//           <ul className="nav-menu" id="nav__menu__display">
//             <li className="nav-header">
//               <IntlMessages id="sidebar.main" />
//             </li>

//             <li className="menu no-arrow">
//               <NavLink to="/app/dashboard/overview">
//                 <i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
//                 <span className="nav-text">
//                   <IntlMessages id="sidebar.dashboard" />
//                 </span>
//               </NavLink>
//             </li>

//             {loginData && loginData.exMember != "1" && (
//               <li className="menu no-arrow">
//                 <NavLink to="/app/calendar/dnd">
//                   <i className="zmdi zmdi-calendar zmdi-hc-fw" />
//                   <span className="nav-text">
//                     <IntlMessages id="sidebar.dashboard.calendar" />
//                   </span>
//                 </NavLink>
//               </li>
//             )}

//             {loginData && loginData.leadsActive == "1" ? (
//               <li className="menu collapse-box">
//                 <Button>
//                   <i className="zmdi zmdi-book zmdi-hc-fw" />
//                   <span className="nav-text">
//                     <IntlMessages id="sidebar.leads" />
//                   </span>
//                 </Button>
//                 <ul className="sub-menu">
//                   <li>
//                     <NavLink className="prepend-icon" to="/app/leads/newleads">
//                       <span className="nav-text">
//                         <IntlMessages id="sidebar.leads.newleads" />
//                       </span>
//                     </NavLink>
//                   </li>

//                   <li>
//                     <NavLink
//                       className="prepend-icon"
//                       to="/app/leads/completedleads"
//                     >
//                       <span className="nav-text">
//                         <IntlMessages id="sidebar.leads.completedleads" />
//                       </span>
//                     </NavLink>
//                   </li>

//                   <li>
//                     <NavLink
//                       className="prepend-icon"
//                       to="/app/leads/ignoredleads"
//                     >
//                       <span className="nav-text">
//                         <IntlMessages id="Snooze Leads" />
//                       </span>
//                     </NavLink>
//                   </li>

//                   <li>
//                     <NavLink
//                       className="prepend-icon"
//                       to="/app/leads/cancelbooking"
//                     >
//                       <span className="nav-text">
//                         <IntlMessages id="Cancellation Request" />
//                       </span>
//                     </NavLink>
//                   </li>
//                   <li>
//                     <NavLink
//                       className="prepend-icon"
//                       to="/app/leads/operatormessage"
//                     >
//                       <span className="nav-text">
//                         <IntlMessages id="Message For Operator" />
//                       </span>
//                     </NavLink>
//                   </li>
//                 </ul>
//               </li>
//             ) : (
//               ""
//             )}

//             {loginData &&
//               loginData.exMember != "1" &&
//               loginData.socialActive == "1" && (
//                 <li className="menu no-arrow">
//                   <NavLink to="/app/social/wall">
//                     <i className="zmdi zmdi-collection-folder-image zmdi-hc-fw" />
//                     <span className="nav-text">
//                       Forum
//                     </span>
//                   </NavLink>
//                 </li>
//               )}

//             {loginData && loginData.exMember != "1" && (
//               <li className="menu no-arrow">
//                 <NavLink to="/app/dashboard/news">
//                   <i className="zmdi zmdi-comment-alert zmdi-hc-fw" />
//                   <span className="nav-text">
//                     <IntlMessages id="sidebar.dashboard.news" />
//                   </span>
//                 </NavLink>
//               </li>
//             )}

//             {loginData && loginData.exMember != "1" && (
//               <li className="menu collapse-box">
//                 <Button>
//                   <i className="zmdi zmdi-book zmdi-hc-fw" />
//                   <span className="nav-text">
//                     <IntlMessages id="sidebar.bookings" />
//                   </span>
//                 </Button>
//                 <ul className="sub-menu">
//                   <li>
//                     <NavLink className="prepend-icon" to="/app/bookings/newbook">
//                       <span className="nav-text">
//                         <IntlMessages id="sidebar.bookings.new" />
//                       </span>
//                     </NavLink>
//                   </li>
//                   <li>
//                     <NavLink
//                       className="prepend-icon"
//                       to="/app/bookings/activebook"
//                     >
//                       <span className="nav-text">
//                         <IntlMessages id="sidebar.bookings.active" />
//                       </span>
//                     </NavLink>
//                   </li>
//                   <li>
//                     <NavLink
//                       className="prepend-icon"
//                       to="/app/bookings/completedbook"
//                     >
//                       <span className="nav-text">
//                         <IntlMessages id="sidebar.bookings.completed" />
//                       </span>
//                     </NavLink>
//                   </li>
//   <li>
//                     <NavLink className="prepend-icon" to="/app/bookings/waitlist">
//                       <span className="nav-text">
//                         <IntlMessages id="sidebar.bookings.waitlist" />
//                       </span>
//                     </NavLink>
//                   </li>
//                    <li>
//                     <NavLink className="prepend-icon" to="/app/bookings/waitlistnewbooking">
//                       <span className="nav-text">
//                         <IntlMessages id="sidebar.bookings.waitlistbookings" />
//                       </span>
//                     </NavLink>
//                   </li>
//                   <li>
//                     <NavLink
//                       className="prepend-icon"
//                       to="/app/bookings/recurringbook"
//                     >
//                       <span className="nav-text">
//                         <IntlMessages id="sidebar.bookings.recurring" />
//                       </span>
//                     </NavLink>
//                   </li>

//                   <li>
//                     <NavLink
//                       className="prepend-icon"
//                       to="/app/bookings/cancelledRecurringbook"
//                     >
//                       <span className="nav-text">
//                         <IntlMessages id="sidebar.bookings.cancelledRecurring" />
//                       </span>
//                     </NavLink>
//                   </li>

//                   <li>
//                     <NavLink
//                       className="prepend-icon"
//                       to="/app/bookings/cancelledbook"
//                     >
//                       <span className="nav-text">
//                         <IntlMessages id="sidebar.bookings.cancelled" />
//                       </span>
//                     </NavLink>
//                   </li>
//                   <li>
//                     <NavLink
//                       className="prepend-icon"
//                       to="/app/bookings/archivedbook"
//                     >
//                       <span className="nav-text">
//                         <IntlMessages id="sidebar.bookings.archived" />
//                       </span>
//                     </NavLink>
//                   </li>
//                 </ul>
//               </li>
//             )}

//             {loginData && loginData.exMember != "1" && (
//               <li className="menu collapse-box">
//                 <Button>
//                   <i className="zmdi zmdi-bookmark zmdi-hc-fw" />
//                   <span className="nav-text">
//                     <IntlMessages id="blockout.menu" />
//                   </span>
//                 </Button>
//                 <ul className="sub-menu">
//                   <li>
//                     <NavLink className="prepend-icon" to="/app/blockout/newblock">
//                       <span className="nav-text">
//                         <IntlMessages id="sidebar.blockout.new" />
//                       </span>
//                     </NavLink>
//                   </li>
//                   <li>
//                     <NavLink
//                       className="prepend-icon"
//                       to="/app/blockout/listblocks"
//                     >
//                       <span className="nav-text">
//                         <IntlMessages id="sidebar.blockout.list" />
//                       </span>
//                     </NavLink>
//                   </li>
//                   <li>
//                     <NavLink
//                       className="prepend-icon"
//                       to="/app/blockout/listrecurringblocks"
//                     >
//                       <span className="nav-text">
//                         <IntlMessages id="sidebar.blockout.listrecurring" />
//                       </span>
//                     </NavLink>
//                   </li>
//                 </ul>
//               </li>
//             )}

//             {loginData && loginData.exMember != "1" && (
//               <li className="menu collapse-box">
//                 <Button>
//                   <i className="zmdi zmdi-account-box zmdi-hc-fw" />
//                   <span className="nav-text">
//                     <IntlMessages id="sidebar.appModule.contact" />
//                   </span>
//                 </Button>
//                 <ul className="sub-menu">
//                   <li>
//                     <NavLink className="prepend-icon" to="/app/newcontact">
//                       <span className="nav-text">
//                         <IntlMessages id="sidebar.customers.add" />
//                       </span>
//                     </NavLink>
//                   </li>
//                   <li>
//                     <NavLink className="prepend-icon" to="/app/contact">
//                       <span className="nav-text">
//                         <IntlMessages id="sidebar.customers.list" />
//                       </span>
//                     </NavLink>
//                   </li>

//                   {featureServer && (
//                     <li>
//                       <NavLink
//                         className="prepend-icon"
//                         to="/app/inactive_customers"
//                       >
//                         <span className="nav-text">
//                           Inactive Customers
//                         </span>
//                       </NavLink>
//                     </li>
//                   )}

//                   <li>
//                     <NavLink className="prepend-icon" to="/app/archivedcontacts">
//                       <span className="nav-text">
//                         <IntlMessages id="sidebar.customers.archivelist" />
//                       </span>
//                     </NavLink>
//                   </li>
//                 </ul>
//               </li>
//             )}

//             {loginData && loginData.exMember != "1" && (
//               <li className="menu collapse-box">
//                 <Button>
//                   <i className="zmdi zmdi-account-box-phone zmdi-hc-fw" />
//                   <span className="nav-text">
//                     <IntlMessages id="sidebar.comm" />
//                   </span>
//                 </Button>
//                 <ul className="sub-menu">
//                   <li>
//                     <NavLink
//                       className="prepend-icon"
//                       to="/app/communication/buycredits"
//                     >
//                       <span className="nav-text">
//                         <IntlMessages id="sidebar.comm.buycredit" />
//                       </span>
//                     </NavLink>
//                   </li>

//                   <li>
//                     <NavLink
//                       className="prepend-icon"
//                       to="/app/communication/sendsms"
//                     >
//                       <span className="nav-text">
//                         <IntlMessages id="sidebar.comm.sendsms" />
//                       </span>
//                     </NavLink>
//                   </li>
//                   <li>
//                     <NavLink
//                       className="prepend-icon"
//                       to="/app/communication/sendemail"
//                     >
//                       <span className="nav-text">
//                         <IntlMessages id="sidebar.comm.sendemail" />
//                       </span>
//                     </NavLink>
//                   </li>
//                   <li>
//                     <NavLink
//                       className="prepend-icon"
//                       to="/app/communication/smshistory"
//                     >
//                       <span className="nav-text">
//                         <IntlMessages id="sidebar.comm.smshistory" />
//                       </span>
//                     </NavLink>
//                   </li>
//                   <li>
//                     <NavLink
//                       className="prepend-icon"
//                       to="/app/communication/emailhistory"
//                     >
//                       <span className="nav-text">
//                         <IntlMessages id="sidebar.comm.emailhistory" />
//                       </span>
//                     </NavLink>
//                   </li>
                  
                    
                  
//                   <li>
//                     <NavLink
//                       className="prepend-icon"
//                       to="/app/communication/emailmarketing"
//                     >
//                       <span className="nav-text">
//                         <IntlMessages id="sidebar.comm.emailmarketing" />
//                       </span>
//                     </NavLink>
//                   </li>
                  

                  
//                   <li>
//                     <NavLink
//                       className="prepend-icon"
//                       to="/app/communication/messagetemplate"
//                     >
//                       <span className="nav-text">
//                         <IntlMessages id="sidebar.comm.messagetemplate" />
//                       </span>
//                     </NavLink>
//                   </li>
//                 </ul>
//               </li>
//             )}

//             {loginData && loginData.exMember != "1" && (
//               <li className="menu collapse-box">
//                 <Button>
//                   <i className="zmdi zmdi-group zmdi-hc-fw" />
//                   <span className="nav-text">
//                     <IntlMessages id="sidebar.inventory" />
//                   </span>
//                 </Button>
//                 <ul className="sub-menu">
                   
//                   <li>
//                     <NavLink
//                       className="prepend-icon"
//                       to="/app/inventory/PlaceOrder"
//                     >
//                       <span className="nav-text">
//                         Office Order
//                       </span>
//                     </NavLink>
//                   </li>
//                   <li>
//                     <NavLink
//                       className="prepend-icon"
//                       to="/app/inventory/PlaceOrderB"
//                     >
//                       <span className="nav-text">Shampoo Order</span>
//                     </NavLink>
//                   </li>

//                   <li>
//                     <NavLink
//                       className="prepend-icon"
//                       to="/app/inventory/PlaceOrderTreat"
//                     >
//                       <span className="nav-text">
//                         <IntlMessages id="sidebar.inventory.placeorderTreat" />
//                       </span>
//                     </NavLink>
//                   </li>

//                   <li>
//                     <NavLink
//                       className="prepend-icon"
//                       to="/app/inventory/PlaceOrderUniform"
//                     >
//                       <span className="nav-text">Place Uniform Orders</span>
//                     </NavLink>
//                   </li>
//                   <li>
//                     <NavLink
//                       className="prepend-icon"
//                       to="/app/inventory/decals"
//                     >
//                       <span className="nav-text">
//                         <IntlMessages id="sidebar.inventory.decals" />
//                       </span>
//                     </NavLink>
//                   </li>
//                   <li>
//                     <NavLink
//                       className="prepend-icon"
//                       to="/app/inventory/PlaceBusinessCard"
//                     >
//                       <span className="nav-text">
//                         Place Business Card, Magnet, Flyers
//                       </span>
//                     </NavLink>
//                   </li>

//                   {(featureServer || this.state.showButton) && (
//                     <li>
//                       <NavLink
//                         className="prepend-icon"
//                         to="/app/inventory/stock_take"
//                       >
//                         <span className="nav-text">Stock Take</span>
//                       </NavLink>
//                     </li>
//                   )}

//                   {featureServer && (
//                     <li>
//                       <NavLink
//                         className="prepend-icon"
//                         to="/app/inventory/stockonhand"
//                       >
//                         <span className="nav-text">Stock On Hand</span>
//                       </NavLink>
//                     </li>
//                   )}

//                   <li>
//                     <NavLink
//                       className="prepend-icon"
//                       to="/app/inventory/InwardGoods"
//                     >
//                       <span className="nav-text">
//                         <IntlMessages id="sidebar.inventory.inwardgoods" />
//                       </span>
//                     </NavLink>
//                   </li>
//                   <li>
//                     <NavLink
//                       className="prepend-icon"
//                       to="/app/inventory/CompletedOrders"
//                     >
//                       <span className="nav-text">
//                         <IntlMessages id="sidebar.inventory.completedorders" />
//                       </span>
//                     </NavLink>
//                   </li>
//                 </ul>
//               </li>
//             )}

//             <li className="menu collapse-box">
//               <Button>
//                 <i className="zmdi zmdi-money-box zmdi-hc-fw" />
//                 <span className="nav-text">
//                   <IntlMessages id="sidebar.income" />
//                 </span>
//               </Button>
//               <ul className="sub-menu">
//                 <li>
//                   <NavLink className="prepend-icon" to="/app/income/AddIncome">
//                     <span className="nav-text">
//                       <IntlMessages id="sidebar.income.addincome" />
//                     </span>
//                   </NavLink>
//                 </li>

//                 {loginData && loginData.exMember != "1" && (
//                   <li>
//                     <NavLink
//                       className="prepend-icon"
//                       to="/app/income/AddIncomeCategory"
//                     >
//                       <span className="nav-text">
//                         <IntlMessages id="sidebar.income.addincomecategory" />
//                       </span>
//                     </NavLink>
//                   </li>
//                 )}
//                 <li>
//                   <NavLink
//                     className="prepend-icon"
//                     to="/app/income/IncomeCategories"
//                   >
//                     <span className="nav-text">
//                       <IntlMessages id="sidebar.income.incomecategories" />
//                     </span>
//                   </NavLink>
//                 </li>

//                 <li>
//                   <NavLink className="prepend-icon" to="/app/income/ListIncome">
//                     <span className="nav-text">
//                       <IntlMessages id="sidebar.income.listincome" />
//                     </span>
//                   </NavLink>
//                 </li>
//                 <li>
//                   <NavLink
//                     className="prepend-icon"
//                     to="/app/income/ListRecurringIncome"
//                   >
//                     <span className="nav-text">
//                       <IntlMessages id="sidebar.income.listrecurringincome" />
//                     </span>
//                   </NavLink>
//                 </li>
//               </ul>
//             </li>

//             <li className="menu collapse-box">
//               <Button>
//                 <i className="zmdi zmdi-money-off zmdi-hc-fw" />
//                 <span className="nav-text">
//                   <IntlMessages id="sidebar.expense" />
//                 </span>
//               </Button>
//               <ul className="sub-menu">
//                 <li>
//                   <NavLink className="prepend-icon" to="/app/expense/AddExpense">
//                     <span className="nav-text">
//                       <IntlMessages id="sidebar.expense.addexpense" />
//                     </span>
//                   </NavLink>
//                 </li>

//                 <li>
//                   <NavLink
//                     className="prepend-icon"
//                     to="/app/expense/ExpenseCategories"
//                   >
//                     <span className="nav-text">
//                       <IntlMessages id="sidebar.expense.expensecategories" />
//                     </span>
//                   </NavLink>
//                 </li>
//                 <li>
//                   <NavLink className="prepend-icon" to="/app/expense/ListExpense">
//                     <span className="nav-text">
//                       <IntlMessages id="sidebar.expense.listexpense" />
//                     </span>
//                   </NavLink>
//                 </li>

//                 <li>
//                   <NavLink
//                     className="prepend-icon"
//                     to="/app/expense/ListRecurringExpense"
//                   >
//                     <span className="nav-text">
//                       <IntlMessages id="sidebar.expense.listrecurringexpense" />
//                     </span>
//                   </NavLink>
//                 </li>
//               </ul>
//             </li>

//             {loginData && loginData.exMember != "1" && (
//               <li className="menu collapse-box">
//                 <Button>
//                   <i className="zmdi zmdi-settings-square zmdi-hc-fw" />
//                   <span className="nav-text">
//                     <IntlMessages id="sidebar.documents.menu" />
//                   </span>
//                 </Button>
//                 <ul className="sub-menu">
//                   <li>
//                     <NavLink className="prepend-icon" to="/app/documents/manuals">
//                       <span className="nav-text">
//                         <IntlMessages id="sidebar.documents.systemManuals" />
//                       </span>
//                     </NavLink>
//                   </li>

//                   <li>
//                     <NavLink
//                       className="prepend-icon"
//                       to="/app/documents/templates"
//                     >
//                       <span className="nav-text">
//                         <IntlMessages id="sidebar.documents.templates" />
//                       </span>
//                     </NavLink>
//                   </li>

//                   <li>
//                     <NavLink
//                       className="prepend-icon"
//                       to="/app/documents/otherfiles"
//                     >
//                       <span className="nav-text">
//                         <IntlMessages id="sidebar.documents.otherfiles" />
//                       </span>
//                     </NavLink>
//                   </li>
//                 </ul>
//               </li>
//             )}

//             <li className="menu collapse-box">
//               <Button>
//                 <i className="zmdi zmdi-trending-up zmdi-hc-fw" />
//                 <span className="nav-text">
//                   <IntlMessages id="sidebar.reports" />
//                 </span>
//               </Button>
//               <ul className="sub-menu">
//                 {loginData && loginData.exMember != "1" && (
//                   <li>
//                     <NavLink
//                       className="prepend-icon"
//                       to="/app/notifications/DailyDiary"
//                     >
//                       <span className="nav-text">
//                         <IntlMessages id="notifications.dailyDiary.menu" />
//                       </span>
//                     </NavLink>
//                   </li>
//                 )}
                
//                 <li>
//                   <NavLink className="prepend-icon" to="/app/reports/Benchmarks">
//                     <span className="nav-text">
//                       Benchmarking Figures
//                     </span>
//                   </NavLink>
//                 </li>

//                 {loginData && loginData.exMember != "1" && (
//                   <li>
//                     <NavLink className="prepend-icon" to="/app/reports/Booking">
//                       <span className="nav-text">
//                         <IntlMessages id="sidebar.reports.bookingreports" />
//                       </span>
//                     </NavLink>
//                   </li>
//                 )}
//                 {loginData && loginData.exMember != "1" && (
//                   <li>
//                     <NavLink className="prepend-icon" to="/app/reports/Service">
//                       <span className="nav-text">
//                         <IntlMessages id="sidebar.reports.servicereports" />
//                       </span>
//                     </NavLink>
//                   </li>
//                 )}
//                 {loginData && loginData.exMember != "1" && (
//                   <li>
//                     <NavLink className="prepend-icon" to="/app/reports/Suburb">
//                       <span className="nav-text">
//                         <IntlMessages id="sidebar.reports.suburbreports" />
//                       </span>
//                     </NavLink>
//                   </li>
//                 )}
//                 {loginData && loginData.exMember != "1" && (
//                   <li>
//                     <NavLink className="prepend-icon" to="/app/reports/Customer">
//                       <span className="nav-text">
//                         <IntlMessages id="sidebar.reports.customerreports" />
//                       </span>
//                     </NavLink>
//                   </li>
//                 )}
//                 <li>
//                   <NavLink className="prepend-icon" to="/app/reports/Income">
//                     <span className="nav-text">
//                       <IntlMessages id="sidebar.reports.incomereports" />
//                     </span>
//                   </NavLink>
//                 </li>
//                 {loginData && loginData.exMember != "1" && (
//                   <li>
//                     <NavLink
//                       className="prepend-icon"
//                       to="/app/reports/IncomeForcast"
//                     >
//                       <span className="nav-text">
//                         <IntlMessages id="sidebar.reports.incomeforcastreports" />
//                       </span>
//                     </NavLink>
//                   </li>
//                 )}

//                 <li>
//                   <NavLink className="prepend-icon" to="/app/reports/Expense">
//                     <span className="nav-text">
//                       <IntlMessages id="sidebar.reports.expensereports" />
//                     </span>
//                   </NavLink>
//                 </li>
//                 <li>
//                   <NavLink className="prepend-icon" to="/app/reports/ProfitLoss">
//                     <span className="nav-text">
//                       <IntlMessages id="sidebar.reports.profitloss" />
//                     </span>
//                   </NavLink>
//                 </li>
//                 <li>
//                   <NavLink
//                     className="prepend-icon"
//                     to="/app/reports/ProfitLossGroup"
//                   >
//                     <span className="nav-text">
//                       <IntlMessages id="sidebar.reports.profitlossgroup" />
//                     </span>
//                   </NavLink>
//                 </li>
//                 <li>
//                   <NavLink className="prepend-icon" to="/app/reports/GST">
//                     <span className="nav-text">
//                       Gst Report Summary
//                     </span>
//                   </NavLink>
//                 </li>
//                 <li>
//                   <NavLink className="prepend-icon" to="/app/reports/GST_DETAIL">
//                     <span className="nav-text">
//                       Gst Report Detail
//                     </span>
//                   </NavLink>
//                 </li>
//                 {featureServer && (
//                   <li>
//                     <NavLink className="prepend-icon" to="/app/reports/GSTCash">
//                       <span className="nav-text">Gst Report (Cash)</span>
//                     </NavLink>
//                   </li>
//                 )}
//                 {loginData && loginData.exMember != "1" && (
//                   <li>
//                     <NavLink className="prepend-icon" to="/app/reports/Tracing">
//                       <span className="nav-text">
//                         <IntlMessages id="sidebar.reports.tracingreports" />
//                       </span>
//                     </NavLink>
//                   </li>
//                 )}
//               </ul>
//             </li>

//             {loginData && loginData.exMember != "1" && (
//               <li className="menu collapse-box">
//                 <Button>
//                   <i className="zmdi zmdi-library zmdi-hc-fw" />
//                   <span className="nav-text">
//                     <IntlMessages id="Training" />
//                   </span>
//                 </Button>
//                 <ul className="sub-menu">
//                   {categories.map((cat, index) => (
//                     <li key={index} className="menu no-arrow">
//                       <NavLink to={`/app/trainingvideos/${cat.slug}`}>
//                         <span className="nav-text">
//                           <IntlMessages
//                             id={cat.name || `sidebar.${cat.name}.menu`}
//                           />
//                         </span>
//                       </NavLink>
//                     </li>
//                   ))}
//                 </ul>
//               </li>
//             )}

//             {loginData && loginData.exMember != "1" && (
//               <li className="menu collapse-box">
//                 <Button>
//                   <i className="zmdi zmdi-inbox zmdi-hc-fw" />
//                   <span className="nav-text">
//                     <IntlMessages id="Orders" />
//                   </span>
//                 </Button>
//                 <ul className="sub-menu">
//                   <li>
//                     <NavLink
//                       className="prepend-icon"
//                       to="/app/orders/smspurchaselog"
//                     >
//                       <span className="nav-text">
//                         <IntlMessages id="SMS Purchase Log" />
//                       </span>
//                     </NavLink>
//                   </li>
//                 </ul>
//               </li>
//             )}

//             {loginData && loginData.exMember != "1" && (
//               <li className="menu collapse-box">
//                 <Button>
//                   <i className="zmdi zmdi-settings-square zmdi-hc-fw" />
//                   <span className="nav-text">
//                     <IntlMessages id="setup" />
//                   </span>
//                 </Button>
//                 <ul className="sub-menu">
//                   <li>
//                     <NavLink
//                       className="prepend-icon"
//                       to="/app/notifications/bookings"
//                     >
//                       <span className="nav-text">
//                         <IntlMessages id="notifications.bookings.menu" />
//                       </span>
//                     </NavLink>
//                   </li>

//                   <li>
//                     <NavLink className="prepend-icon" to="/app/settings">
//                       <span className="nav-text">
//                         <IntlMessages id="sidebar.dashboard.settings" />
//                       </span>
//                     </NavLink>
//                   </li>

//                   <li>
//                     <NavLink className="prepend-icon" to="/app/inventory_usage">
//                       <span className="nav-text">Inventory Usage</span>
//                     </NavLink>
//                   </li>

//                   <li>
//                     <NavLink className="prepend-icon" to="/app/myPrices">
//                       <span className="nav-text">
//                         <IntlMessages id="sidebar.dashboard.myprices" />
//                       </span>
//                     </NavLink>
//                   </li>
//                 </ul>
//               </li>
//             )}

//             {featureServer && (
//               <li className="menu collapse-box">
//                 <Button>
//                   <i className="zmdi zmdi-chart-donut zmdi-hc-fw" />
//                   <span className="nav-text">Integraton</span>
//                 </Button>
//                 <ul className="sub-menu">
//                   <li>
//                     <NavLink className="prepend-icon" to="/app/app_integration">
//                       <span className="nav-text">App</span>
//                     </NavLink>
//                   </li>
//                 </ul>
//               </li>
//             )}

//             {loginData && loginData.exMember != "1" && (
//               <li className="menu no-arrow lawaBottomMenu">
//                 <NavLink to="/app/version">
//                   <i className="zmdi zmdi-time-restore zmdi-hc-fw" />
//                   <span className="nav-text">Version Update</span>
//                 </NavLink>
//               </li>
//             )}

//             {
//               loginData && loginData.exMember != "1" && (
//                 <li
//                   className="menu no-arrow lawaBottomMenu"
//                   style={{ cursor: "pointer" }}
//                 >
//                   <NavLink to="/app/manual/manual">
//                     <i className="zmdi zmdi-sign-in zmdi-hc-fw" />
//                     <span className="nav-text">
//                       <IntlMessages id="sidebar.manual.menu" />
//                     </span>
//                   </NavLink>
//                 </li>
//               )}

//             {loginData && loginData.exMember != "1" && (
//               <li className="menu no-arrow lawaBottomMenu">
//                 <NavLink to="/app/ticket/ticket">
//                   <i className="zmdi zmdi-bug zmdi-hc-fw" />
//                   <span className="nav-text">
//                     <IntlMessages id="sidebar.ticket.menu" />
//                   </span>
//                 </NavLink>
//               </li>
//             )}

//             {/* Download Button with Drawer Functionality */}

            
//        {
       
//        loginData && loginData.exMember != "1" && (
//   <div style={{
//     position: 'sticky',
//     bottom: '20px',
//     margin: '20px 15px 10px 15px',
//     zIndex: 100
//   }}>
//     {/* Download Button with Integrated Toggle */}
//     <div style={{
//       transform: this.state.downloadDrawerOpen ? 'translateX(0)' : 'translateX(-100%)',
//       opacity: this.state.downloadDrawerOpen ? 1 : 0,
//       transition: 'all 0.3s ease',
//       position: 'relative'
//     }}>
//       <div className="menu no-arrow" style={{ 
//         border: '1px solid #3F51B5',
//         borderRadius: '8px',
//         backgroundColor: 'rgba(63, 81, 181, 0.9)',
//         boxShadow: '0 4px 12px rgba(63, 81, 181, 0.4)',
//         overflow: 'hidden',
//         margin: 0,
//         backdropFilter: 'blur(10px)',
//         WebkitBackdropFilter: 'blur(10px)',
//         display: 'flex',
//         alignItems: 'center',
//       }}>
//         {/* Toggle Arrow Inside Button - Seamless with button */}
//         <div 
//           style={{
//             // padding: '2px 1px',
//             cursor: 'pointer',
//             color: 'white',
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//             transition: 'all 0.2s ease'
//           }}
//           onClick={this.toggleDownloadDrawer}
//           onMouseEnter={(e) => {
//             e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
//           }}
//           onMouseLeave={(e) => {
//             e.currentTarget.style.backgroundColor = 'transparent';
//           }}
//         >
//           {this.state.downloadDrawerOpen ? 
//             <ChevronLeftIcon style={{ fontSize: '20px' }} /> : 
//             <ChevronRightIcon style={{ fontSize: '20px' }} />
//           }
//         </div>
        
//         {/* Simple Download Button Text */}

        
//         <Link
//   to="/app/downloadapp"   // React Router handles SPA navigation
//   style={{
//     flex: 1,
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "flex-start",
//     padding: "6px 0px",
//     color: "white",
//     fontWeight: "bold",
//     textDecoration: "none",
//     cursor: "pointer",
//     transition: "all 0.2s ease"
//   }}
//   onMouseEnter={(e) => {
//     e.currentTarget.style.backgroundColor = "rgba(255, 255, 255, 0.1)";
//   }}
//   onMouseLeave={(e) => {
//     e.currentTarget.style.backgroundColor = "transparent";
//   }}
// >
//   <div style={{ 
//     display: 'flex', 
//     alignItems: 'center',
//     paddingLeft: '6px' 
//   }}>
//     {/* iOS Icon */}
//     <i className="zmdi zmdi-apple zmdi-hc-fw" style={{ fontSize: '20px' }} />

//     {/* Separator */}
//     <span style={{ fontSize: '16px', opacity: '0.7' }}>/</span>

//     {/* Android Icon */}
//     <i className="zmdi zmdi-android zmdi-hc-fw" style={{ fontSize: '20px' }} />

//     {/* Text */}
//     <span style={{ marginLeft: '8px', fontSize: '14px', fontWeight: '600' }}>
//       Download App
//     </span>
//   </div>
// </Link>

//       </div>
//     </div>
    
//     {/* Floating toggle icon when drawer is closed */}
//     {!this.state.downloadDrawerOpen && (
//   <div 
//     style={{
//       position: 'absolute',
//       top: '50%',
//       left: '10px',
//       transform: 'translateY(-50%)',
//       zIndex: 101,
//       backgroundColor: 'rgba(63, 81, 181, 0.9)',
//       borderRadius: '50%',
//       width: '36px',
//       height: '36px',
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center',
//       boxShadow: '0 3px 10px rgba(63, 81, 181, 0.5)',
//       cursor: 'pointer',
//       color: 'white',
//       fontSize: '16px',
//       transition: 'all 0.2s ease',
//       border: '1px solid #3F51B5',
//       // display : "none",

//       /* ✅ Add pulsating animation */
//       animation: 'pulse 1.5s infinite ease-in-out',
//     }}
//     onClick={this.toggleDownloadDrawer}
//     onMouseEnter={(e) => {
//       e.currentTarget.style.backgroundColor = "rgba(92, 107, 192, 0.9)";
//       e.currentTarget.style.transform = "translateY(-50%) scale(1.05)";
//     }}
//     onMouseLeave={(e) => {
//       e.currentTarget.style.backgroundColor = "rgba(63, 81, 181, 0.9)";
//       e.currentTarget.style.transform = "translateY(-50%) scale(1)";
//     }}
//   >
//     <ChevronRightIcon style={{ fontSize: '20px' }} />
//   </div>
// )}

//   </div>
// )}
//           </ul>
//         </CustomScrollbars>

//         <Snackbar
//           anchorOrigin={{
//             vertical: 'top',
//             horizontal: 'right',
//           }}
//           open={this.state.iosSnackbarOpen}
//           autoHideDuration={5000}
//           onClose={this.handleSnackbarClose}
//         >
//           <Alert 
//             onClose={this.handleSnackbarClose} 
//             severity={this.state.iosSnackbarSeverity || "info"}
//             variant="filled"
//             style={{ width: '100%' }}
//           >
//             {this.state.iosSnackbarMessage}
//           </Alert>
//         </Snackbar>
//       </>
//     );
//   }
// }

// export default withRouter(SidenavContent);

// ********************************************************************************************************************************************************************************

import React, { Component } from "react";
import { NavLink, withRouter } from "react-router-dom";
import Button from "@material-ui/core/Button";
import GlobalURL from "appUtility/global";
import featureServer from "./../../appUtility/featureServer";
import { httpClient } from "appUtility/Api";
import qs from "qs";

import IntlMessages from "util/IntlMessages";
import CustomScrollbars from "util/CustomScrollbars";
import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';
import { Link } from 'react-router-dom';

// Add these imports for drawer controls
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

const loginData = JSON.parse(localStorage.getItem("login"));

class SidenavContent extends Component {
  constructor() {
    super();

     const savedDrawerState = localStorage.getItem('downloadDrawerOpen');
    this.state = {
  showButton: false,
  categories: [],
  iosSnackbarOpen: false,
  iosSnackbarMessage: "",
  iosDownloadLink: "",
  isIosLoading: false,
  downloadDrawerOpen: savedDrawerState === null ? true : savedDrawerState === 'true',
  // ADD THESE TWO NEW PROPERTIES:
  menuVisibility: {
  officeOrder: true,        // Changed from false to true
  shampooOrder: true,       // Changed from false to true
  treatOrder: true,         // Changed from false to true
  uniformOrder: true,       // Changed from false to true
  decals: true,             // Changed from false to true
  flyersBusinessCards: true // Changed from false to true
},
  isLoadingMenus: true
};
  }
  
  componentDidMount() {
    // Check if download drawer state is saved in localStorage
    // const savedDrawerState = localStorage.getItem('downloadDrawerOpen');
    // if (savedDrawerState !== null) {
    //   this.setState({ downloadDrawerOpen: savedDrawerState === 'true' });
    // }
    
    const loginOBJ = JSON.parse(localStorage.getItem("login"));
    const { aid, cid } = loginOBJ;

    httpClient
      .post(
        "v2/trainingCategories.php",
        qs.stringify({
          action: "getList",
          "source[appID]": aid,
          "source[companyID]": cid,
        })
      )
      .then((res) => {
        if (res.data.success) {
          this.setState({ categories: res.data.data });
        }
      })
      .catch((error) => {
        console.error("Error fetching categories:", error);
      });

    this.checkTime();

    this.intervalId = setInterval(this.checkTime, 60000);
this.loadMenuVisibility();
    const { history } = this.props;
    const that = this;
    const pathname = `${history.location.pathname}`; // get current path

    const menuLi = document.getElementsByClassName("menu");
    for (let i = 0; i < menuLi.length; i++) {
      menuLi[i].onclick = function(event) {
        for (let j = 0; j < menuLi.length; j++) {
          const parentLi = that.closest(this, "li");
          if (
            menuLi[j] !== this &&
            (parentLi === null || !parentLi.classList.contains("open"))
          ) {
            menuLi[j].classList.remove("open");
          }
        }
        this.classList.toggle("open");
      };
    }

    const activeLi = document.querySelector('a[href="' + pathname + '"]'); // select current a element
    try {
      const activeNav = this.closest(activeLi, "ul"); // select closest ul
      if (activeNav.classList.contains("sub-menu")) {
        this.closest(activeNav, "li").classList.add("open");
      } else {
        this.closest(activeLi, "li").classList.add("open");
      }
    } catch (error) {}
  }

  componentWillUnmount() {
    // Cleanup interval on component unmount
    clearInterval(this.intervalId);
  }
// Load menu visibility from API with localStorage caching
loadMenuVisibility = () => {
  const loginOBJ = JSON.parse(localStorage.getItem("login"));
  const aid = loginOBJ.aid;
  const cid = loginOBJ.cid;
  const uid = loginOBJ.uid;
  const memtoken = loginOBJ.memtoken;
  
  // Create cache key
  const cacheKey = "menuVisibility_" + aid + "_" + cid;
  const cacheTimestamp = cacheKey + "_timestamp";
  const cacheDuration = 5 * 60 * 1000; // 5 minutes cache duration
  
  // Check localStorage cache first
  const cachedData = localStorage.getItem(cacheKey);
  const cachedTime = localStorage.getItem(cacheTimestamp);
  
  if (cachedData && cachedTime && (Date.now() - parseInt(cachedTime)) < cacheDuration) {
    // Use cached data
    this.setState({
      menuVisibility: JSON.parse(cachedData),
      isLoadingMenus: false
    });
    return;
  }
  
  // Fetch from API if cache is expired or doesn't exist
  httpClient.post(
    "v2/getInventoryCount.php",
    qs.stringify({
      accessToken: memtoken,
      action: "countByCategory",
      "source[appID]": aid,
      "source[memberID]": uid,
      "source[companyID]": cid,
    })
  )
  .then((response) => {
    if (response.data.success) {
      const data = response.data.data;
      
      // Find counts for each category based on cat_key
      let officeOrderCount = 0;
      let shampooOrderCount = 0;
      let treatOrderCount = 0;
      let uniformOrderCount = 0;
      let decalsCount = 0;
      let flyersCount = 0;
      
      for (var i = 0; i < data.length; i++) {
        if (data[i].cat_key === "shampoo") {
          officeOrderCount = data[i].total;
        } else if (data[i].cat_key === "shampoo_winc") {
          shampooOrderCount = data[i].total;
        } else if (data[i].cat_key === "treats") {
          treatOrderCount = data[i].total;
        } else if (data[i].cat_key === "uniform") {
          uniformOrderCount = data[i].total;
        } else if (data[i].cat_key === "decals") {
          decalsCount = data[i].total;
        } else if (data[i].cat_key === "flyers") {
          flyersCount = data[i].total;
        }
      }
      
      // Determine which menus to show based on counts > 0
      const menuVisibility = {
        officeOrder: officeOrderCount > 0,
        shampooOrder: shampooOrderCount > 0,
        treatOrder: treatOrderCount > 0,
        uniformOrder: uniformOrderCount > 0,
        decals: decalsCount > 0,
        flyersBusinessCards: flyersCount > 0
      };
      
      // Save to localStorage with timestamp
      localStorage.setItem(cacheKey, JSON.stringify(menuVisibility));
      localStorage.setItem(cacheTimestamp, Date.now().toString());
      
      this.setState({
        menuVisibility: menuVisibility,
        isLoadingMenus: false
      });
    } else {
      this.setState({ isLoadingMenus: false });
    }
  })
  .catch((error) => {
    console.error("Error fetching menu counts:", error);
    this.setState({ isLoadingMenus: false });
  });
};

// Call this method after placing an order or when inventory changes
refreshInventoryMenus = () => {
  const loginOBJ = JSON.parse(localStorage.getItem("login"));
  const aid = loginOBJ.aid;
  const cid = loginOBJ.cid;
  const cacheKey = "menuVisibility_" + aid + "_" + cid;
  localStorage.removeItem(cacheKey);
  localStorage.removeItem(cacheKey + "_timestamp");
  this.loadMenuVisibility();
};
  checkTime = () => {
    // Get the current date and time in Australian Eastern Time (Sydney)
    const now = new Date();
    const options = {
      timeZone: "Australia/Sydney",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    };
    const formatter = new Intl.DateTimeFormat("en-AU", options);
    const parts = formatter.formatToParts(now);
    const dateParts = parts.reduce((acc, part) => {
      acc[part.type] = part.value;
      return acc;
    }, {});

    const currentDate = new Date(
      `${dateParts.year}-${dateParts.month}-${dateParts.day}T${dateParts.hour}:${dateParts.minute}:${dateParts.second}+10:00` // +10:00 for AEST
    );

    // Define the target date and time: June 28, 2024, 6:30 PM in Sydney
    const targetDate = new Date("2024-06-30T15:25:00+10:00"); 

    // Check if the current date and time is after the target date and time
    if (currentDate >= targetDate) {
      this.setState({ showButton: true });
    } else {
      this.setState({ showButton: false });
    }
  };

  componentWillReceiveProps(nextProps) {
    const { history } = nextProps;
    const pathname = `${history.location.pathname}`; // get current path

    const activeLi = document.querySelector('a[href="' + pathname + '"]'); // select current a element
    try {
      const activeNav = this.closest(activeLi, "ul"); // select closest ul
      if (activeNav.classList.contains("sub-menu")) {
        this.closest(activeNav, "li").classList.add("open");
      } else {
        this.closest(activeLi, "li").classList.add("open");
      }
    } catch (error) {}
  }

  closest(el, selector) {
    try {
      let matchesFn;
      // find vendor prefix
      [
        "matches",
        "webkitMatchesSelector",
        "mozMatchesSelector",
        "msMatchesSelector",
        "oMatchesSelector",
      ].some(function(fn) {
        if (typeof document.body[fn] == "function") {
          matchesFn = fn;
          return true;
        }
        return false;
      });

      let parent;

      // traverse parents
      while (el) {
        parent = el.parentElement;
        if (parent && parent[matchesFn](selector)) {
          return parent;
        }
        el = parent;
      }
    } catch (e) {}

    return null;
  }

  // Toggle download drawer only
  toggleDownloadDrawer = () => {
    const newState = !this.state.downloadDrawerOpen;
    this.setState({ downloadDrawerOpen: newState });
    localStorage.setItem('downloadDrawerOpen', newState.toString());
  };

  // handleDownloadIOS = () => {
  //   const loginOBJ = JSON.parse(localStorage.getItem("login"));
  //   const { aid, cid } = loginOBJ;

  //   this.setState({
  //     isIosLoading: true,
  //     iosSnackbarMessage: "Preparing download link...",
  //     iosSnackbarOpen: true,
  //     iosSnackbarSeverity: "success"
  //   });

  //   // Make API call to get download link
  //   httpClient
  //     .post(
  //       "v2/downloadLink.php",
  //       qs.stringify({
  //         action: "getLink",
  //         "source[appID]": aid,
  //         "source[companyID]": cid,
  //       })
  //     )
  //     .then((res) => {
  //       if (res.data.success) {
  //         this.setState({
  //           iosSnackbarMessage: res.data.message || "Download link ready! Redirecting...",
  //           iosDownloadLink: res.data.download,
  //           iosSnackbarSeverity: "success"
  //         });

  //         // Wait 2 seconds before redirecting
  //         setTimeout(() => {
  //           window.open(res.data.download, "_blank");
  //           this.setState({
  //             isIosLoading: false,
  //             iosSnackbarOpen: false
  //           });
  //         }, 2000);
  //       } else {
  //         const errorMessage = res.data.message || "Failed to get download link. Please try again.";
  //         this.setState({
  //           iosSnackbarMessage: errorMessage,
  //           iosSnackbarSeverity: "error",
  //           isIosLoading: false
  //         });
  //       }
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching download link:", error);
  //       this.setState({
  //         iosSnackbarMessage: "Network error. Please check your connection.",
  //         iosSnackbarSeverity: "error",
  //         isIosLoading: false
  //       });
  //     });
  // };

  handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({ iosSnackbarOpen: false });
  };

  handleOpenNewPage = () => {
    window.open("https://bluewheelers.opcentral.com.au", "_blank");
  };

  render() {
    const { categories,menuVisibility, isLoadingMenus } = this.state;
  
    return (
      <>
        <CustomScrollbars className=" scrollbar">
          <ul className="nav-menu" id="nav__menu__display">
            <li className="nav-header">
              <IntlMessages id="sidebar.main" />
            </li>

            <li className="menu no-arrow">
              <NavLink to="/app/dashboard/overview">
                <i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
                <span className="nav-text">
                  <IntlMessages id="sidebar.dashboard" />
                </span>
              </NavLink>
            </li>

            {loginData && loginData.exMember != "1" && (
              <li className="menu no-arrow">
                <NavLink to="/app/calendar/dnd">
                  <i className="zmdi zmdi-calendar zmdi-hc-fw" />
                  <span className="nav-text">
                    <IntlMessages id="sidebar.dashboard.calendar" />
                  </span>
                </NavLink>
              </li>
            )}

            {loginData && loginData.leadsActive == "1" ? (
              <li className="menu collapse-box">
                <Button>
                  <i className="zmdi zmdi-book zmdi-hc-fw" />
                  <span className="nav-text">
                    <IntlMessages id="sidebar.leads" />
                  </span>
                </Button>
                <ul className="sub-menu">
                  <li>
                    <NavLink className="prepend-icon" to="/app/leads/newleads">
                      <span className="nav-text">
                        <IntlMessages id="sidebar.leads.newleads" />
                      </span>
                    </NavLink>
                  </li>

                  <li>
                    <NavLink
                      className="prepend-icon"
                      to="/app/leads/completedleads"
                    >
                      <span className="nav-text">
                        <IntlMessages id="sidebar.leads.completedleads" />
                      </span>
                    </NavLink>
                  </li>

                  <li>
                    <NavLink
                      className="prepend-icon"
                      to="/app/leads/ignoredleads"
                    >
                      <span className="nav-text">
                        <IntlMessages id="Snooze Leads" />
                      </span>
                    </NavLink>
                  </li>

                  <li>
                    <NavLink
                      className="prepend-icon"
                      to="/app/leads/cancelbooking"
                    >
                      <span className="nav-text">
                        <IntlMessages id="Cancellation Request" />
                      </span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      className="prepend-icon"
                      to="/app/leads/operatormessage"
                    >
                      <span className="nav-text">
                        <IntlMessages id="Message For Operator" />
                      </span>
                    </NavLink>
                  </li>
                </ul>
              </li>
            ) : (
              ""
            )}

            {loginData &&
              loginData.exMember != "1" &&
              loginData.socialActive == "1" && (
                <li className="menu no-arrow">
                  <NavLink to="/app/social/wall">
                    <i className="zmdi zmdi-collection-folder-image zmdi-hc-fw" />
                    <span className="nav-text">
                      Forum
                    </span>
                  </NavLink>
                </li>
              )}

            {loginData && loginData.exMember != "1" && (
              <li className="menu no-arrow">
                <NavLink to="/app/dashboard/news">
                  <i className="zmdi zmdi-comment-alert zmdi-hc-fw" />
                  <span className="nav-text">
                    <IntlMessages id="sidebar.dashboard.news" />
                  </span>
                </NavLink>
              </li>
            )}

            {loginData && loginData.exMember != "1" && (
              <li className="menu collapse-box">
                <Button>
                  <i className="zmdi zmdi-book zmdi-hc-fw" />
                  <span className="nav-text">
                    <IntlMessages id="sidebar.bookings" />
                  </span>
                </Button>
                <ul className="sub-menu">
                  <li>
                    <NavLink className="prepend-icon" to="/app/bookings/newbook">
                      <span className="nav-text">
                        <IntlMessages id="sidebar.bookings.new" />
                      </span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      className="prepend-icon"
                      to="/app/bookings/activebook"
                    >
                      <span className="nav-text">
                        <IntlMessages id="sidebar.bookings.active" />
                      </span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      className="prepend-icon"
                      to="/app/bookings/completedbook"
                    >
                      <span className="nav-text">
                        <IntlMessages id="sidebar.bookings.completed" />
                      </span>
                    </NavLink>
                  </li>
  <li>
                    <NavLink className="prepend-icon" to="/app/bookings/waitlist">
                      <span className="nav-text">
                        <IntlMessages id="sidebar.bookings.waitlist" />
                      </span>
                    </NavLink>
                  </li>
                   <li>
                    <NavLink className="prepend-icon" to="/app/bookings/waitlistnewbooking">
                      <span className="nav-text">
                        <IntlMessages id="sidebar.bookings.waitlistbookings" />
                      </span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      className="prepend-icon"
                      to="/app/bookings/recurringbook"
                    >
                      <span className="nav-text">
                        <IntlMessages id="sidebar.bookings.recurring" />
                      </span>
                    </NavLink>
                  </li>

                  <li>
                    <NavLink
                      className="prepend-icon"
                      to="/app/bookings/cancelledRecurringbook"
                    >
                      <span className="nav-text">
                        <IntlMessages id="sidebar.bookings.cancelledRecurring" />
                      </span>
                    </NavLink>
                  </li>

                  <li>
                    <NavLink
                      className="prepend-icon"
                      to="/app/bookings/cancelledbook"
                    >
                      <span className="nav-text">
                        <IntlMessages id="sidebar.bookings.cancelled" />
                      </span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      className="prepend-icon"
                      to="/app/bookings/archivedbook"
                    >
                      <span className="nav-text">
                        <IntlMessages id="sidebar.bookings.archived" />
                      </span>
                    </NavLink>
                  </li>
                </ul>
              </li>
            )}

            {loginData && loginData.exMember != "1" && (
              <li className="menu collapse-box">
                <Button>
                  <i className="zmdi zmdi-bookmark zmdi-hc-fw" />
                  <span className="nav-text">
                    <IntlMessages id="blockout.menu" />
                  </span>
                </Button>
                <ul className="sub-menu">
                  <li>
                    <NavLink className="prepend-icon" to="/app/blockout/newblock">
                      <span className="nav-text">
                        <IntlMessages id="sidebar.blockout.new" />
                      </span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      className="prepend-icon"
                      to="/app/blockout/listblocks"
                    >
                      <span className="nav-text">
                        <IntlMessages id="sidebar.blockout.list" />
                      </span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      className="prepend-icon"
                      to="/app/blockout/listrecurringblocks"
                    >
                      <span className="nav-text">
                        <IntlMessages id="sidebar.blockout.listrecurring" />
                      </span>
                    </NavLink>
                  </li>
                </ul>
              </li>
            )}

            {loginData && loginData.exMember != "1" && (
              <li className="menu collapse-box">
                <Button>
                  <i className="zmdi zmdi-account-box zmdi-hc-fw" />
                  <span className="nav-text">
                    <IntlMessages id="sidebar.appModule.contact" />
                  </span>
                </Button>
                <ul className="sub-menu">
                  <li>
                    <NavLink className="prepend-icon" to="/app/newcontact">
                      <span className="nav-text">
                        <IntlMessages id="sidebar.customers.add" />
                      </span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink className="prepend-icon" to="/app/contact">
                      <span className="nav-text">
                        <IntlMessages id="sidebar.customers.list" />
                      </span>
                    </NavLink>
                  </li>

                  {featureServer && (
                    <li>
                      <NavLink
                        className="prepend-icon"
                        to="/app/inactive_customers"
                      >
                        <span className="nav-text">
                          Inactive Customers
                        </span>
                      </NavLink>
                    </li>
                  )}

                  <li>
                    <NavLink className="prepend-icon" to="/app/archivedcontacts">
                      <span className="nav-text">
                        <IntlMessages id="sidebar.customers.archivelist" />
                      </span>
                    </NavLink>
                  </li>
                </ul>
              </li>
            )}

            {loginData && loginData.exMember != "1" && (
              <li className="menu collapse-box">
                <Button>
                  <i className="zmdi zmdi-account-box-phone zmdi-hc-fw" />
                  <span className="nav-text">
                    <IntlMessages id="sidebar.comm" />
                  </span>
                </Button>
                <ul className="sub-menu">
                  <li>
                    <NavLink
                      className="prepend-icon"
                      to="/app/communication/buycredits"
                    >
                      <span className="nav-text">
                        <IntlMessages id="sidebar.comm.buycredit" />
                      </span>
                    </NavLink>
                  </li>

                  <li>
                    <NavLink
                      className="prepend-icon"
                      to="/app/communication/sendsms"
                    >
                      <span className="nav-text">
                        <IntlMessages id="sidebar.comm.sendsms" />
                      </span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      className="prepend-icon"
                      to="/app/communication/sendemail"
                    >
                      <span className="nav-text">
                        <IntlMessages id="sidebar.comm.sendemail" />
                      </span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      className="prepend-icon"
                      to="/app/communication/smshistory"
                    >
                      <span className="nav-text">
                        <IntlMessages id="sidebar.comm.smshistory" />
                      </span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      className="prepend-icon"
                      to="/app/communication/emailhistory"
                    >
                      <span className="nav-text">
                        <IntlMessages id="sidebar.comm.emailhistory" />
                      </span>
                    </NavLink>
                  </li>
                  
                    {
                      featureServer && (
                   
                  
                  <li>
                    <NavLink
                      className="prepend-icon"
                      to="/app/communication/emailmarketing"
                    >
                      <span className="nav-text">
                        <IntlMessages id="sidebar.comm.emailmarketing" />
                      </span>
                    </NavLink>
                  </li>
                  ) }

                  
                  <li>
                    <NavLink
                      className="prepend-icon"
                      to="/app/communication/messagetemplate"
                    >
                      <span className="nav-text">
                        <IntlMessages id="sidebar.comm.messagetemplate" />
                      </span>
                    </NavLink>
                  </li>
                </ul>
              </li>
            )}

            {/* {loginData && loginData.exMember != "1" && (
              <li className="menu collapse-box">
                <Button>
                  <i className="zmdi zmdi-group zmdi-hc-fw" />
                  <span className="nav-text">
                    <IntlMessages id="sidebar.inventory" />
                  </span>
                </Button>
                <ul className="sub-menu">
                   
                  <li>
                    <NavLink
                      className="prepend-icon"
                      to="/app/inventory/PlaceOrder"
                    >
                      <span className="nav-text">
                        Office Order
                      </span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      className="prepend-icon"
                      to="/app/inventory/PlaceOrderB"
                    >
                      <span className="nav-text">Shampoo Order</span>
                    </NavLink>
                  </li>

                  <li>
                    <NavLink
                      className="prepend-icon"
                      to="/app/inventory/PlaceOrderTreat"
                    >
                      <span className="nav-text">
                        <IntlMessages id="sidebar.inventory.placeorderTreat" />
                      </span>
                    </NavLink>
                  </li>

                  <li>
                    <NavLink
                      className="prepend-icon"
                      to="/app/inventory/PlaceOrderUniform"
                    >
                      <span className="nav-text">Place Uniform Orders</span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      className="prepend-icon"
                      to="/app/inventory/decals"
                    >
                      <span className="nav-text">
                        <IntlMessages id="sidebar.inventory.decals" />
                      </span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      className="prepend-icon"
                      to="/app/inventory/PlaceBusinessCard"
                    >
                      <span className="nav-text">
                        Place Business Card, Magnet, Flyers
                      </span>
                    </NavLink>
                  </li>

                  {(featureServer || this.state.showButton) && (
                    <li>
                      <NavLink
                        className="prepend-icon"
                        to="/app/inventory/stock_take"
                      >
                        <span className="nav-text">Stock Take</span>
                      </NavLink>
                    </li>
                  )}

                  {featureServer && (
                    <li>
                      <NavLink
                        className="prepend-icon"
                        to="/app/inventory/stockonhand"
                      >
                        <span className="nav-text">Stock On Hand</span>
                      </NavLink>
                    </li>
                  )}

                  <li>
                    <NavLink
                      className="prepend-icon"
                      to="/app/inventory/InwardGoods"
                    >
                      <span className="nav-text">
                        <IntlMessages id="sidebar.inventory.inwardgoods" />
                      </span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      className="prepend-icon"
                      to="/app/inventory/CompletedOrders"
                    >
                      <span className="nav-text">
                        <IntlMessages id="sidebar.inventory.completedorders" />
                      </span>
                    </NavLink>
                  </li>
                </ul>
              </li>
            )} */}
{loginData && loginData.exMember != "1" && (
  (menuVisibility.officeOrder || menuVisibility.shampooOrder || menuVisibility.treatOrder || 
   menuVisibility.uniformOrder || menuVisibility.decals || menuVisibility.flyersBusinessCards || 
   featureServer || this.state.showButton) && (
    <li className="menu collapse-box">
      <Button>
        <i className="zmdi zmdi-group zmdi-hc-fw" />
        <span className="nav-text">
          <IntlMessages id="sidebar.inventory" />
        </span>
      </Button>
      <ul className="sub-menu">
        
        {menuVisibility.officeOrder && (
          <li>
            <NavLink
              className="prepend-icon"
              to="/app/inventory/PlaceOrder"
            >
              <span className="nav-text">
                Office Order
              </span>
            </NavLink>
          </li>
        )}
        
        {menuVisibility.shampooOrder && (
          <li>
            <NavLink
              className="prepend-icon"
              to="/app/inventory/PlaceOrderB"
            >
              <span className="nav-text">Shampoo Order</span>
            </NavLink>
          </li>
        )}

        {menuVisibility.treatOrder && (
          <li>
            <NavLink
              className="prepend-icon"
              to="/app/inventory/PlaceOrderTreat"
            >
              <span className="nav-text">
                <IntlMessages id="sidebar.inventory.placeorderTreat" />
              </span>
            </NavLink>
          </li>
        )}

        {menuVisibility.uniformOrder && (
          <li>
            <NavLink
              className="prepend-icon"
              to="/app/inventory/PlaceOrderUniform"
            >
              <span className="nav-text">Place Uniform Orders</span>
            </NavLink>
          </li>
        )}
        
        {menuVisibility.decals && (
          <li>
            <NavLink
              className="prepend-icon"
              to="/app/inventory/decals"
            >
              <span className="nav-text">
                <IntlMessages id="sidebar.inventory.decals" />
              </span>
            </NavLink>
          </li>
        )}
        
        {menuVisibility.flyersBusinessCards && (
          <li>
            <NavLink
              className="prepend-icon"
              to="/app/inventory/PlaceBusinessCard"
            >
              <span className="nav-text">
                Place Business Card, Magnet, Flyers
              </span>
            </NavLink>
          </li>
        )}

        {(featureServer || this.state.showButton) && (
          <li>
            <NavLink
              className="prepend-icon"
              to="/app/inventory/stock_take"
            >
              <span className="nav-text">Stock Take</span>
            </NavLink>
          </li>
        )}

        {featureServer && (
          <li>
            <NavLink
              className="prepend-icon"
              to="/app/inventory/stockonhand"
            >
              <span className="nav-text">Stock On Hand</span>
            </NavLink>
          </li>
        )}

        <li>
          <NavLink
            className="prepend-icon"
            to="/app/inventory/InwardGoods"
          >
            <span className="nav-text">
              <IntlMessages id="sidebar.inventory.inwardgoods" />
            </span>
          </NavLink>
        </li>
        <li>
          <NavLink
            className="prepend-icon"
            to="/app/inventory/CompletedOrders"
          >
            <span className="nav-text">
              <IntlMessages id="sidebar.inventory.completedorders" />
            </span>
          </NavLink>
        </li>
      </ul>
    </li>
  )
)}
            <li className="menu collapse-box">
              <Button>
                <i className="zmdi zmdi-money-box zmdi-hc-fw" />
                <span className="nav-text">
                  <IntlMessages id="sidebar.income" />
                </span>
              </Button>
              <ul className="sub-menu">
                <li>
                  <NavLink className="prepend-icon" to="/app/income/AddIncome">
                    <span className="nav-text">
                      <IntlMessages id="sidebar.income.addincome" />
                    </span>
                  </NavLink>
                </li>

                {loginData && loginData.exMember != "1" && (
                  <li>
                    <NavLink
                      className="prepend-icon"
                      to="/app/income/AddIncomeCategory"
                    >
                      <span className="nav-text">
                        <IntlMessages id="sidebar.income.addincomecategory" />
                      </span>
                    </NavLink>
                  </li>
                )}
                <li>
                  <NavLink
                    className="prepend-icon"
                    to="/app/income/IncomeCategories"
                  >
                    <span className="nav-text">
                      <IntlMessages id="sidebar.income.incomecategories" />
                    </span>
                  </NavLink>
                </li>

                <li>
                  <NavLink className="prepend-icon" to="/app/income/ListIncome">
                    <span className="nav-text">
                      <IntlMessages id="sidebar.income.listincome" />
                    </span>
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    className="prepend-icon"
                    to="/app/income/ListRecurringIncome"
                  >
                    <span className="nav-text">
                      <IntlMessages id="sidebar.income.listrecurringincome" />
                    </span>
                  </NavLink>
                </li>
              </ul>
            </li>

            <li className="menu collapse-box">
              <Button>
                <i className="zmdi zmdi-money-off zmdi-hc-fw" />
                <span className="nav-text">
                  <IntlMessages id="sidebar.expense" />
                </span>
              </Button>
              <ul className="sub-menu">
                <li>
                  <NavLink className="prepend-icon" to="/app/expense/AddExpense">
                    <span className="nav-text">
                      <IntlMessages id="sidebar.expense.addexpense" />
                    </span>
                  </NavLink>
                </li>

                <li>
                  <NavLink
                    className="prepend-icon"
                    to="/app/expense/ExpenseCategories"
                  >
                    <span className="nav-text">
                      <IntlMessages id="sidebar.expense.expensecategories" />
                    </span>
                  </NavLink>
                </li>
                <li>
                  <NavLink className="prepend-icon" to="/app/expense/ListExpense">
                    <span className="nav-text">
                      <IntlMessages id="sidebar.expense.listexpense" />
                    </span>
                  </NavLink>
                </li>

                <li>
                  <NavLink
                    className="prepend-icon"
                    to="/app/expense/ListRecurringExpense"
                  >
                    <span className="nav-text">
                      <IntlMessages id="sidebar.expense.listrecurringexpense" />
                    </span>
                  </NavLink>
                </li>
              </ul>
            </li>

            {loginData && loginData.exMember != "1" && (
              <li className="menu collapse-box">
                <Button>
                  <i className="zmdi zmdi-settings-square zmdi-hc-fw" />
                  <span className="nav-text">
                    <IntlMessages id="sidebar.documents.menu" />
                  </span>
                </Button>
                <ul className="sub-menu">
                  <li>
                    <NavLink className="prepend-icon" to="/app/documents/manuals">
                      <span className="nav-text">
                        <IntlMessages id="sidebar.documents.systemManuals" />
                      </span>
                    </NavLink>
                  </li>

                  <li>
                    <NavLink
                      className="prepend-icon"
                      to="/app/documents/templates"
                    >
                      <span className="nav-text">
                        <IntlMessages id="sidebar.documents.templates" />
                      </span>
                    </NavLink>
                  </li>

                  <li>
                    <NavLink
                      className="prepend-icon"
                      to="/app/documents/otherfiles"
                    >
                      <span className="nav-text">
                        <IntlMessages id="sidebar.documents.otherfiles" />
                      </span>
                    </NavLink>
                  </li>
                </ul>
              </li>
            )}

            <li className="menu collapse-box">
              <Button>
                <i className="zmdi zmdi-trending-up zmdi-hc-fw" />
                <span className="nav-text">
                  <IntlMessages id="sidebar.reports" />
                </span>
              </Button>
              <ul className="sub-menu">
                {loginData && loginData.exMember != "1" && (
                  <li>
                    <NavLink
                      className="prepend-icon"
                      to="/app/notifications/DailyDiary"
                    >
                      <span className="nav-text">
                        <IntlMessages id="notifications.dailyDiary.menu" />
                      </span>
                    </NavLink>
                  </li>
                )}
                
                <li>
                  <NavLink className="prepend-icon" to="/app/reports/Benchmarks">
                    <span className="nav-text">
                      Benchmarking Figures
                    </span>
                  </NavLink>
                </li>

                {loginData && loginData.exMember != "1" && (
                  <li>
                    <NavLink className="prepend-icon" to="/app/reports/Booking">
                      <span className="nav-text">
                        <IntlMessages id="sidebar.reports.bookingreports" />
                      </span>
                    </NavLink>
                  </li>
                )}
                {loginData && loginData.exMember != "1" && (
                  <li>
                    <NavLink className="prepend-icon" to="/app/reports/Service">
                      <span className="nav-text">
                        <IntlMessages id="sidebar.reports.servicereports" />
                      </span>
                    </NavLink>
                  </li>
                )}
                {loginData && loginData.exMember != "1" && (
                  <li>
                    <NavLink className="prepend-icon" to="/app/reports/Suburb">
                      <span className="nav-text">
                        <IntlMessages id="sidebar.reports.suburbreports" />
                      </span>
                    </NavLink>
                  </li>
                )}
                {loginData && loginData.exMember != "1" && (
                  <li>
                    <NavLink className="prepend-icon" to="/app/reports/Customer">
                      <span className="nav-text">
                        <IntlMessages id="sidebar.reports.customerreports" />
                      </span>
                    </NavLink>
                  </li>
                )}
                <li>
                  <NavLink className="prepend-icon" to="/app/reports/Income">
                    <span className="nav-text">
                      <IntlMessages id="sidebar.reports.incomereports" />
                    </span>
                  </NavLink>
                </li>
                {loginData && loginData.exMember != "1" && (
                  <li>
                    <NavLink
                      className="prepend-icon"
                      to="/app/reports/IncomeForcast"
                    >
                      <span className="nav-text">
                        <IntlMessages id="sidebar.reports.incomeforcastreports" />
                      </span>
                    </NavLink>
                  </li>
                )}

                <li>
                  <NavLink className="prepend-icon" to="/app/reports/Expense">
                    <span className="nav-text">
                      <IntlMessages id="sidebar.reports.expensereports" />
                    </span>
                  </NavLink>
                </li>
                <li>
                  <NavLink className="prepend-icon" to="/app/reports/ProfitLoss">
                    <span className="nav-text">
                      <IntlMessages id="sidebar.reports.profitloss" />
                    </span>
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    className="prepend-icon"
                    to="/app/reports/ProfitLossGroup"
                  >
                    <span className="nav-text">
                      <IntlMessages id="sidebar.reports.profitlossgroup" />
                    </span>
                  </NavLink>
                </li>
                <li>
                  <NavLink className="prepend-icon" to="/app/reports/GST">
                    <span className="nav-text">
                      Gst Report Summary
                    </span>
                  </NavLink>
                </li>
                <li>
                  <NavLink className="prepend-icon" to="/app/reports/GST_DETAIL">
                    <span className="nav-text">
                      Gst Report Detail
                    </span>
                  </NavLink>
                </li>
                {featureServer && (
                  <li>
                    <NavLink className="prepend-icon" to="/app/reports/GSTCash">
                      <span className="nav-text">Gst Report (Cash)</span>
                    </NavLink>
                  </li>
                )}
                {loginData && loginData.exMember != "1" && (
                  <li>
                    <NavLink className="prepend-icon" to="/app/reports/Tracing">
                      <span className="nav-text">
                        <IntlMessages id="sidebar.reports.tracingreports" />
                      </span>
                    </NavLink>
                  </li>
                )}
              </ul>
            </li>

            {loginData && loginData.exMember != "1" && (
              <li className="menu collapse-box">
                <Button>
                  <i className="zmdi zmdi-library zmdi-hc-fw" />
                  <span className="nav-text">
                    <IntlMessages id="Training" />
                  </span>
                </Button>
                <ul className="sub-menu">
                  {categories.map((cat, index) => (
                    <li key={index} className="menu no-arrow">
                      <NavLink to={`/app/trainingvideos/${cat.slug}`}>
                        <span className="nav-text">
                          <IntlMessages
                            id={cat.name || `sidebar.${cat.name}.menu`}
                          />
                        </span>
                      </NavLink>
                    </li>
                  ))}
                </ul>
              </li>
            )}

            {loginData && loginData.exMember != "1" && (
              <li className="menu collapse-box">
                <Button>
                  <i className="zmdi zmdi-inbox zmdi-hc-fw" />
                  <span className="nav-text">
                    <IntlMessages id="Orders" />
                  </span>
                </Button>
                <ul className="sub-menu">
                  <li>
                    <NavLink
                      className="prepend-icon"
                      to="/app/orders/smspurchaselog"
                    >
                      <span className="nav-text">
                        <IntlMessages id="SMS Purchase Log" />
                      </span>
                    </NavLink>
                  </li>
                </ul>
              </li>
            )}

            {loginData && loginData.exMember != "1" && (
              <li className="menu collapse-box">
                <Button>
                  <i className="zmdi zmdi-settings-square zmdi-hc-fw" />
                  <span className="nav-text">
                    <IntlMessages id="setup" />
                  </span>
                </Button>
                <ul className="sub-menu">
                  <li>
                    <NavLink
                      className="prepend-icon"
                      to="/app/notifications/bookings"
                    >
                      <span className="nav-text">
                        <IntlMessages id="notifications.bookings.menu" />
                      </span>
                    </NavLink>
                  </li>

                  <li>
                    <NavLink className="prepend-icon" to="/app/settings">
                      <span className="nav-text">
                        <IntlMessages id="sidebar.dashboard.settings" />
                      </span>
                    </NavLink>
                  </li>

                  <li>
                    <NavLink className="prepend-icon" to="/app/inventory_usage">
                      <span className="nav-text">Inventory Usage</span>
                    </NavLink>
                  </li>

                  <li>
                    <NavLink className="prepend-icon" to="/app/myPrices">
                      <span className="nav-text">
                        <IntlMessages id="sidebar.dashboard.myprices" />
                      </span>
                    </NavLink>
                  </li>
                </ul>
              </li>
            )}

            {featureServer && (
              <li className="menu collapse-box">
                <Button>
                  <i className="zmdi zmdi-chart-donut zmdi-hc-fw" />
                  <span className="nav-text">Integraton</span>
                </Button>
                <ul className="sub-menu">
                  <li>
                    <NavLink className="prepend-icon" to="/app/app_integration">
                      <span className="nav-text">App</span>
                    </NavLink>
                  </li>
                </ul>
              </li>
            )}

            {loginData && loginData.exMember != "1" && (
              <li className="menu no-arrow lawaBottomMenu">
                <NavLink to="/app/version">
                  <i className="zmdi zmdi-time-restore zmdi-hc-fw" />
                  <span className="nav-text">Version Update</span>
                </NavLink>
              </li>
            )}

            {
              loginData && loginData.exMember != "1" && (
                <li
                  className="menu no-arrow lawaBottomMenu"
                  style={{ cursor: "pointer" }}
                >
                  <NavLink to="/app/manual/manual">
                    <i className="zmdi zmdi-sign-in zmdi-hc-fw" />
                    <span className="nav-text">
                      <IntlMessages id="sidebar.manual.menu" />
                    </span>
                  </NavLink>
                </li>
              )}

            {loginData && loginData.exMember != "1" && (
              <li className="menu no-arrow lawaBottomMenu">
                <NavLink to="/app/ticket/ticket">
                  <i className="zmdi zmdi-bug zmdi-hc-fw" />
                  <span className="nav-text">
                    <IntlMessages id="sidebar.ticket.menu" />
                  </span>
                </NavLink>
              </li>
            )}

            {/* Download Button with Drawer Functionality */}

            
       {
       
       loginData && loginData.exMember != "1" && (
  <div style={{
    position: 'sticky',
    bottom: '20px',
    margin: '20px 15px 10px 15px',
    zIndex: 100
  }}>
    {/* Download Button with Integrated Toggle */}
    <div style={{
      transform: this.state.downloadDrawerOpen ? 'translateX(0)' : 'translateX(-100%)',
      opacity: this.state.downloadDrawerOpen ? 1 : 0,
      transition: 'all 0.3s ease',
      position: 'relative'
    }}>
      <div className="menu no-arrow" style={{ 
        border: '1px solid #3F51B5',
        borderRadius: '8px',
        backgroundColor: 'rgba(63, 81, 181, 0.9)',
        boxShadow: '0 4px 12px rgba(63, 81, 181, 0.4)',
        overflow: 'hidden',
        margin: 0,
        backdropFilter: 'blur(10px)',
        WebkitBackdropFilter: 'blur(10px)',
        display: 'flex',
        alignItems: 'center',
      }}>
        {/* Toggle Arrow Inside Button - Seamless with button */}
        <div 
          style={{
            // padding: '2px 1px',
            cursor: 'pointer',
            color: 'white',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'all 0.2s ease'
          }}
          onClick={this.toggleDownloadDrawer}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = 'transparent';
          }}
        >
          {this.state.downloadDrawerOpen ? 
            <ChevronLeftIcon style={{ fontSize: '20px' }} /> : 
            <ChevronRightIcon style={{ fontSize: '20px' }} />
          }
        </div>
        
        {/* Simple Download Button Text */}

        
        <Link
  to="/app/downloadapp"   // React Router handles SPA navigation
  style={{
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    padding: "6px 0px",
    color: "white",
    fontWeight: "bold",
    textDecoration: "none",
    cursor: "pointer",
    transition: "all 0.2s ease"
  }}
  onMouseEnter={(e) => {
    e.currentTarget.style.backgroundColor = "rgba(255, 255, 255, 0.1)";
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.backgroundColor = "transparent";
  }}
>
  <div style={{ 
    display: 'flex', 
    alignItems: 'center',
    paddingLeft: '6px' 
  }}>
    {/* iOS Icon */}
    <i className="zmdi zmdi-apple zmdi-hc-fw" style={{ fontSize: '20px' }} />

    {/* Separator */}
    <span style={{ fontSize: '16px', opacity: '0.7' }}>/</span>

    {/* Android Icon */}
    <i className="zmdi zmdi-android zmdi-hc-fw" style={{ fontSize: '20px' }} />

    {/* Text */}
    <span style={{ marginLeft: '8px', fontSize: '14px', fontWeight: '600' }}>
      Download App
    </span>
  </div>
</Link>

      </div>
    </div>
    
    {/* Floating toggle icon when drawer is closed */}
    {!this.state.downloadDrawerOpen && (
  <div 
    style={{
      position: 'absolute',
      top: '50%',
      left: '10px',
      transform: 'translateY(-50%)',
      zIndex: 101,
      backgroundColor: 'rgba(63, 81, 181, 0.9)',
      borderRadius: '50%',
      width: '36px',
      height: '36px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      boxShadow: '0 3px 10px rgba(63, 81, 181, 0.5)',
      cursor: 'pointer',
      color: 'white',
      fontSize: '16px',
      transition: 'all 0.2s ease',
      border: '1px solid #3F51B5',
      // display : "none",

      /* ✅ Add pulsating animation */
      animation: 'pulse 1.5s infinite ease-in-out',
    }}
    onClick={this.toggleDownloadDrawer}
    onMouseEnter={(e) => {
      e.currentTarget.style.backgroundColor = "rgba(92, 107, 192, 0.9)";
      e.currentTarget.style.transform = "translateY(-50%) scale(1.05)";
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.backgroundColor = "rgba(63, 81, 181, 0.9)";
      e.currentTarget.style.transform = "translateY(-50%) scale(1)";
    }}
  >
    <ChevronRightIcon style={{ fontSize: '20px' }} />
  </div>
)}

  </div>
)}
          </ul>
        </CustomScrollbars>

        <Snackbar
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          open={this.state.iosSnackbarOpen}
          autoHideDuration={5000}
          onClose={this.handleSnackbarClose}
        >
          <Alert 
            onClose={this.handleSnackbarClose} 
            severity={this.state.iosSnackbarSeverity || "info"}
            variant="filled"
            style={{ width: '100%' }}
          >
            {this.state.iosSnackbarMessage}
          </Alert>
        </Snackbar>
      </>
    );
  }
}

export default withRouter(SidenavContent);